export const ProviderStatusTypes = {
  ACTIVE: 1,
  INACTIVE: 2,
};
